__turbopack_context__.v({
  "active": "styles-module__1wNL6W__active",
  "checkIcon": "styles-module__1wNL6W__checkIcon",
  "list": "styles-module__1wNL6W__list",
  "option": "styles-module__1wNL6W__option",
});
